import { useRef, useCallback, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import React, { Fragment, memo } from 'react'
import { Notification, Columns, Column } from 'Components/common/bulma'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'

const NotificationItem = memo(({ uuid, message, type, onRemove }) => (
  <Notification key={uuid} success={type === 'success'} danger={type === 'danger'} className="mensaje-notificacion">
    <button className="delete" onClick={() => onRemove(uuid)}></button>
    <Columns>
      <Column className="is-3">
        {type === 'success' && (<FontAwesomeIcon icon={faCheck} size="3x"/>)}
        {type === 'danger' && (<FontAwesomeIcon icon={faTimes} size="3x"/>)}
      </Column>
      <Column>
        {message}
      </Column>
    </Columns>
  </Notification>
))

const NotificationsContainer = memo(({ notifications, onRemove }) => {
  return (
    <Fragment>
      {notifications.map((notification) => (
        <NotificationItem 
          key={notification.uuid}
          {...notification}
          onRemove={onRemove}
        />
      ))}
    </Fragment>
  )
})

const useNotification = () => {
  const [notifications, setNotifications] = useState([])
  const notificationsRef = useRef([])

  const addNotification = useCallback(({ message, type }) => {
    const uuid = uuidv4()
    const newNotification = { uuid, message, type }
    
    notificationsRef.current = [...notificationsRef.current, newNotification]
    setNotifications(notificationsRef.current)

    // Auto-eliminar la notificación después de 3 segundos
    setTimeout(() => {
      notificationsRef.current = notificationsRef.current.filter(n => n.uuid !== uuid)
      setNotifications(notificationsRef.current)
    }, 3000)
  }, [])

  const removeNotification = useCallback((uuid) => {
    notificationsRef.current = notificationsRef.current.filter(n => n.uuid !== uuid)
    setNotifications(notificationsRef.current)
  }, [])

  const clearNotifications = useCallback(() => {
    notificationsRef.current = []
    setNotifications([])
  }, [])

  const NotificationUI = useCallback(() => (
    <NotificationsContainer 
      notifications={notifications} 
      onRemove={removeNotification}
    />
  ), [notifications, removeNotification])

  return { 
    notifications,
    addNotification,
    removeNotification,
    clearNotifications,
    NotificationUI
  }
}

export default useNotification